import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const SuccessHeader = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  font-weight: 600;
  text-align: center;
`;

export const ImageContainer = styled.div`
  height: 240px;
  width: 240px;
`;

export const SuccessText = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  text-align: center;
`;

export const FailContainer = styled(SuccessContainer)``;

export const FailHeader = styled(SuccessHeader)``;

export const FailText = styled(SuccessText)``;
